import React from 'react';
import Icon from '../../../components/AppIcon';

const FilterStats = ({ 
  totalCount = 0, 
  filteredCount = 0, 
  searchTerm, 
  selectedCategory,
  selectedStatus,
  stats 
}) => {
  if (!stats) return null;

  const getFilterSummary = () => {
    const filters = [];
    
    if (selectedCategory !== 'all') {
      filters?.push(`${selectedCategory} category`);
    }
    
    if (selectedStatus !== 'all') {
      filters?.push(`${selectedStatus} badges`);
    }
    
    return filters?.length > 0 ? ` (${filters?.join(', ')})` : '';
  };

  return (
    <div className="bg-white bg-opacity-10 backdrop-blur-sm border border-white border-opacity-20 rounded-xl p-6 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {/* Total Badges */}
        <div className="text-center">
          <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-2">
            <Icon name="Award" size={20} className="text-blue-200" />
          </div>
          <div className="text-2xl font-bold text-white mb-1">
            {totalCount}
          </div>
          <div className="text-sm text-blue-200">
            Total Badges{getFilterSummary()}
          </div>
        </div>

        {/* Active Badges */}
        <div className="text-center">
          <div className="w-12 h-12 bg-green-500 bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-2">
            <Icon name="Eye" size={20} className="text-green-300" />
          </div>
          <div className="text-2xl font-bold text-white mb-1">
            {stats?.active_badges || 0}
          </div>
          <div className="text-sm text-green-300">
            Active Badges
          </div>
        </div>

        {/* Total Assignments */}
        <div className="text-center">
          <div className="w-12 h-12 bg-purple-500 bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-2">
            <Icon name="Users" size={20} className="text-purple-300" />
          </div>
          <div className="text-2xl font-bold text-white mb-1">
            {stats?.total_assignments || 0}
          </div>
          <div className="text-sm text-purple-300">
            Total Assignments
          </div>
        </div>

        {/* Earned Badges */}
        <div className="text-center">
          <div className="w-12 h-12 bg-yellow-500 bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-2">
            <Icon name="Star" size={20} className="text-yellow-300" />
          </div>
          <div className="text-2xl font-bold text-white mb-1">
            {stats?.earned_badges || 0}
          </div>
          <div className="text-sm text-yellow-300">
            Badges Earned
          </div>
        </div>
      </div>
      {/* Category Breakdown */}
      {Object.keys(stats?.by_category || {})?.length > 0 && (
        <div className="mt-6 pt-6 border-t border-white border-opacity-20">
          <h4 className="text-sm font-medium text-blue-100 mb-3">By Category</h4>
          <div className="flex flex-wrap gap-2">
            {Object.entries(stats?.by_category)?.map(([category, count]) => (
              <div 
                key={category}
                className={`px-3 py-1 rounded-full text-xs font-medium border ${
                  selectedCategory === category 
                    ? 'bg-blue-500 bg-opacity-30 text-blue-200 border-blue-400' :'bg-white bg-opacity-10 text-blue-300 border-white border-opacity-20'
                }`}
              >
                {category?.charAt(0)?.toUpperCase() + category?.slice(1)}: {count}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterStats;